import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const  realizarAlteracaoSenha = async (parametros) => {
  const { data, status } = await api.post('/resetar_senha', parametros, {headers: iniciarRequisicao()}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return;
  }

  logout();
}

class UsuarioAPI {


  async login(headers, params) {
    const response = await api({
      method: 'post',
      url: '/login',
      headers,
      data: params
    });
    return response;
  }

  async updatePass(headers, params) {
    const response = await api({
      method: 'post',
      url: '/updatePass',
      headers,
      data: params
    });
    return response;
  }

  async getAcessos(headers, params) {

    const response = await api.get("/getAcessos", { headers, params });
    return response;
  }


  async getUsuarios(headers, params) {

    const response = await api.get("/getUsuarios", { headers, params });
    return response;
  }

  async getPerfis(headers, params) {

    const response = await api.get("/getPerfis", { headers, params });
    return response;
  }

  async salvar(headers, params) {
    const response = await api({
      method: 'post',
      url: '/addUsuario',
      headers,
      data: params
    });
    return response;
  }


  async deletar(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delUsuario',
      headers,
      data: params
    });
    return response;
  }

  async resetarSenha(headers, params) {
    const response = await api({
      method: 'put',
      url: '/resetar_senha',
      headers,
      data: params
    });
    return response;
  }

  async setAtualizarSistema(headers, params) {
    const response = await api({
      method: 'put',
      url: '/atuazacao_sistema',
      headers,
      data: params,
    });
    return response;
  }

  async verificarEmail(headers, params) {
    const response = await api({
      method: 'post',
      url: '/verificar_email',
      headers,
      data: params,
    });
    return response;
  }

  async verificarCodigo(headers, params) {
    return await api({
      method: 'post',
      url: '/verificar_codigo',
      headers,
      data: params,
    });
  }

  async verificaUsoEmail(headers, params) {
    const response = await api.get("/email_existe", { headers, params });
    return response;
  }

  async getLicencasUsuarios(headers) {
    const response = await api.get("/getLicencasUsuarios", {headers})
    return response;
  }

  async mudarEstadoAtivacaoUsuario(headers, params) {
    const response = await api.post("/usuarios/ativo", params, {headers})
    return response;
  }

}

export default new UsuarioAPI();
